import React from 'react';
import PropTypes from 'prop-types';

const Echoes = (props) => {
  const { value } = props;
  const formattedValue = (value / 100).toFixed(2);
  return (
    <div className="js-item-price price item__price">
      {formattedValue}
      {' '}
    </div>
  );
};

Echoes.propTypes = {
  value: PropTypes.number.isRequired,
};

export default Echoes;
